// src/stores/counterStore.js
import { defineStore } from "pinia";

export const useCounterStore = defineStore("counter", {
  state: () => ({
    count: 0,
    token: localStorage.getItem("token") || null, // 从 localStorage 获取 token
    info: "",
  }),
  actions: {
    increment() {
      this.count++;
    },
    decrement() {
      this.count--;
    },
    reset() {
      this.count = 0;
    },
    setToken(newToken) {
      this.token = newToken; // 设置 token
      localStorage.setItem("token", newToken); // 将 token 存储到 localStorage
    },
    clearToken() {
      this.token = null; // 清除 token
      localStorage.removeItem("token"); // 从 localStorage 中移除 token
    },
    setInfo(newInfo) {
      this.info = newInfo; // 设置用户信息
    },
  },
});
